'use strict';

module.exports = require('react/lib/ReactDOM');



/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/company/react/build/packages/react-dom/index.js
 ** module id = 265
 ** module chunks = 2
 **/